/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WorkOrderTicketReportSummaryDto } from './WorkOrderTicketReportSummaryDto';
import {
    WorkOrderTicketReportSummaryDtoFromJSON,
    WorkOrderTicketReportSummaryDtoFromJSONTyped,
    WorkOrderTicketReportSummaryDtoToJSON,
    WorkOrderTicketReportSummaryDtoToJSONTyped,
} from './WorkOrderTicketReportSummaryDto';

/**
 * 
 * @export
 * @interface TicketVisitReportDto
 */
export interface TicketVisitReportDto {
    /**
     * 
     * @type {string}
     * @memberof TicketVisitReportDto
     */
    membershipId: string;
    /**
     * 
     * @type {string}
     * @memberof TicketVisitReportDto
     */
    workOrderId: string;
    /**
     * 
     * @type {string}
     * @memberof TicketVisitReportDto
     */
    workOrderCode: string;
    /**
     * 
     * @type {number}
     * @memberof TicketVisitReportDto
     */
    executionNumber: number;
    /**
     * 
     * @type {string}
     * @memberof TicketVisitReportDto
     */
    membershipStatus: TicketVisitReportDtoMembershipStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof TicketVisitReportDto
     */
    completedAt?: Date | null;
    /**
     * 
     * @type {object}
     * @memberof TicketVisitReportDto
     */
    completedById?: object | null;
    /**
     * Display name of who completed this visit
     * @type {object}
     * @memberof TicketVisitReportDto
     */
    completedByName?: object | null;
    /**
     * 
     * @type {string}
     * @memberof TicketVisitReportDto
     */
    executionResult?: TicketVisitReportDtoExecutionResultEnum | null;
    /**
     * 
     * @type {WorkOrderTicketReportSummaryDto}
     * @memberof TicketVisitReportDto
     */
    report?: WorkOrderTicketReportSummaryDto | null;
}


/**
 * @export
 */
export const TicketVisitReportDtoMembershipStatusEnum = {
    Active: 'ACTIVE',
    MovedOut: 'MOVED_OUT',
    Cancelled: 'CANCELLED'
} as const;
export type TicketVisitReportDtoMembershipStatusEnum = typeof TicketVisitReportDtoMembershipStatusEnum[keyof typeof TicketVisitReportDtoMembershipStatusEnum];

/**
 * @export
 */
export const TicketVisitReportDtoExecutionResultEnum = {
    CompletedOk: 'COMPLETED_OK',
    CompletedWithIssue: 'COMPLETED_WITH_ISSUE',
    NotDone: 'NOT_DONE',
    Cancelled: 'CANCELLED'
} as const;
export type TicketVisitReportDtoExecutionResultEnum = typeof TicketVisitReportDtoExecutionResultEnum[keyof typeof TicketVisitReportDtoExecutionResultEnum];


/**
 * Check if a given object implements the TicketVisitReportDto interface.
 */
export function instanceOfTicketVisitReportDto(value: object): value is TicketVisitReportDto {
    if (!('membershipId' in value) || value['membershipId'] === undefined) return false;
    if (!('workOrderId' in value) || value['workOrderId'] === undefined) return false;
    if (!('workOrderCode' in value) || value['workOrderCode'] === undefined) return false;
    if (!('executionNumber' in value) || value['executionNumber'] === undefined) return false;
    if (!('membershipStatus' in value) || value['membershipStatus'] === undefined) return false;
    return true;
}

export function TicketVisitReportDtoFromJSON(json: any): TicketVisitReportDto {
    return TicketVisitReportDtoFromJSONTyped(json, false);
}

export function TicketVisitReportDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TicketVisitReportDto {
    if (json == null) {
        return json;
    }
    return {
        
        'membershipId': json['membershipId'],
        'workOrderId': json['workOrderId'],
        'workOrderCode': json['workOrderCode'],
        'executionNumber': json['executionNumber'],
        'membershipStatus': json['membershipStatus'],
        'completedAt': json['completedAt'] == null ? undefined : (new Date(json['completedAt'])),
        'completedById': json['completedById'] == null ? undefined : json['completedById'],
        'completedByName': json['completedByName'] == null ? undefined : json['completedByName'],
        'executionResult': json['executionResult'] == null ? undefined : json['executionResult'],
        'report': json['report'] == null ? undefined : WorkOrderTicketReportSummaryDtoFromJSON(json['report']),
    };
}

export function TicketVisitReportDtoToJSON(json: any): TicketVisitReportDto {
    return TicketVisitReportDtoToJSONTyped(json, false);
}

export function TicketVisitReportDtoToJSONTyped(value?: TicketVisitReportDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'membershipId': value['membershipId'],
        'workOrderId': value['workOrderId'],
        'workOrderCode': value['workOrderCode'],
        'executionNumber': value['executionNumber'],
        'membershipStatus': value['membershipStatus'],
        'completedAt': value['completedAt'] == null ? value['completedAt'] : value['completedAt'].toISOString(),
        'completedById': value['completedById'],
        'completedByName': value['completedByName'],
        'executionResult': value['executionResult'],
        'report': WorkOrderTicketReportSummaryDtoToJSON(value['report']),
    };
}

